import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=16d7b73b&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=16d7b73b&prod&scoped=true&lang=scss"
import style1 from "./UserInfo.vue?vue&type=style&index=1&id=16d7b73b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d7b73b",
  null
  
)

export default component.exports